import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import cns from '../../node_modules/classnames/index.js';
import DeleteIcon from '../Icons/DeleteIcon.js';

function Tag(_a) {
    var { children, className, onClose, type } = _a, others = __rest(_a, ["children", "className", "onClose", "type"]);
    return (jsxs("span", Object.assign({ className: cns('tag', type ? (`tag--${type}`) : '', className) }, others, { children: [children, onClose && (jsx("span", { className: "tag__close", onClick: onClose, role: "presentation", children: jsx(DeleteIcon, {}) }))] })));
}
Tag.defaultProps = {
    children: null,
    className: '',
    onClose: null,
    type: '',
};

export { Tag as default };
